/**
 * The urlshot.io logo: the corner-bracket mark beside the wordmark, as one image.
 *
 * An SVG (`docs/brand/urlshot-logo-small-inverse.svg`) drawn on the pixel grid of its 28 px height,
 * so it stays crisp on standard-density screens. Its wordmark is light: everywhere the dashboard
 * shows the logo -- the header and the sign-in screens -- is dark, as on the marketing site. The alt
 * text is the name, so a link around the logo still reads as "urlshot.io" to a screen reader.
 *
 * The width and height reserve the logo's space before it loads, so the header does not shift.
 */
import { cn } from '@urlshot/ui';

export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/brand/urlshot-logo-small-inverse.svg"
      width={143}
      height={28}
      alt="urlshot.io"
      className={cn('block h-7 w-auto', className)}
    />
  );
}
